import { usePeriodsQuery } from '@/app/services/periodApi';
import { usePeriod } from '@/context/PeriodContext';
import { useYear } from '@/context/yearsContext';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function PeriodInitializer() {
  const { setSelectedPeriod } = usePeriod();
  const { selectedYear } = useYear();

  const { data, isSuccess } = usePeriodsQuery({ date: selectedYear as string }, { skip: !selectedYear });

  useEffect(() => {
    if (isSuccess && data) {
      const openedPeriod = data.find((item) => item.status === 'OPENED');
      if (openedPeriod) {
        setSelectedPeriod(openedPeriod);
      } else {
        setSelectedPeriod(data[0]);
      }
    }
  }, [data, isSuccess, setSelectedPeriod]);

  return <Outlet />;
}
